import { Component, Input, OnInit, OnDestroy, NgZone, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  whatsApp = "";
  routerLink_URL = environment.url_version == '' ? `${environment.url_version}` : `/${environment.url_version}`;
  
  clickCount = 0;
  clickTimer: any;
  easterEggActive = false;
  animationId: any;
  toolItems: ToolItem[] = [];
  toolCount = 60;
  
  mechanicTools = [
    { icon: 'fa-wrench', weight: 10 },
    { icon: 'fa-screwdriver', weight: 10 },
    { icon: 'fa-hammer', weight: 10 },
    { icon: 'fa-oil-can', weight: 8 },
    { icon: 'fa-car-battery', weight: 5 },
    { icon: 'fa-cog', weight: 15 },
    { icon: 'fa-tools', weight: 10 },
    { icon: 'fa-car', weight: 5 },
    { icon: 'fa-gas-pump', weight: 5 },
    { icon: 'fa-tachometer-alt', weight: 8 },
    { icon: 'fa-bolt', weight: 8 },
    { icon: 'fa-key', weight: 8 },
    { icon: 'fa-paint-roller', weight: 5 },
    { icon: 'fa-plug', weight: 8 }
  ];
  
  toolColors = [
    '#e30614',
    '#f39c12',
    '#3498db',
    '#2ecc71',
    '#9b59b6',
    '#e74c3c',
    '#1abc9c',
    '#d35400',
    '#2980b9',
    '#f1c40f'
  ];
  
  specialTools = [
    'fa-trophy',
    'fa-star',
    'fa-certificate',
    'fa-medal'
  ];

  constructor(
    private _router: Router, 
    private ngZone: NgZone,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.detectar_mobile();
  }
  
  ngOnDestroy() {
    this.stopEasterEgg();
    clearTimeout(this.clickTimer);
  }
  
  logoClick() {
    this.clickCount++;
    
    clearTimeout(this.clickTimer);
    
    this.clickTimer = setTimeout(() => {
      this.clickCount = 0;
    }, 800);
    
    if (this.clickCount >= 5) {
      this.startEasterEgg();
      this.clickCount = 0;
    }
  }
  
  startEasterEgg() {
    if (this.easterEggActive) return;
    
    this.easterEggActive = true;
    this.toolItems = [];
    
    const toolsContainer = document.querySelector('.tool-shower');
    if (toolsContainer) {
      while (toolsContainer.firstChild) {
        toolsContainer.removeChild(toolsContainer.firstChild);
      }
    }
    
    for (let i = 0; i < this.toolCount; i++) {
      setTimeout(() => {
        this.createToolItem();
      }, i * 30);
    }
    
    this.ngZone.runOutsideAngular(() => {
      this.animationId = requestAnimationFrame(() => this.animateTools());
    });
    
    setTimeout(() => {
      this.stopEasterEgg();
    }, 8000);
  }
  
  stopEasterEgg() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
    
    this.easterEggActive = false;
    this.toolItems = [];
    
    const toolsContainer = document.querySelector('.tool-shower');
    if (toolsContainer) {
      const tools = toolsContainer.querySelectorAll('.tool-item');
      
      tools.forEach((tool: HTMLElement) => {
        tool.style.transition = 'opacity 0.5s ease-out';
        tool.style.opacity = '0';
      });
      
      setTimeout(() => {
        while (toolsContainer.firstChild) {
          toolsContainer.removeChild(toolsContainer.firstChild);
        }
      }, 500);
    }
  }
  
  createToolItem() {
    if (!this.easterEggActive) return;
    
    const toolsContainer = document.querySelector('.tool-shower');
    if (!toolsContainer) return;
    
    const isSpecial = Math.random() < 0.08;
    
    let toolIcon;
    if (isSpecial) {
      toolIcon = this.specialTools[Math.floor(Math.random() * this.specialTools.length)];
    } else {
      const totalWeight = this.mechanicTools.reduce((sum, tool) => sum + tool.weight, 0);
      
      let random = Math.random() * totalWeight;
      for (const tool of this.mechanicTools) {
        random -= tool.weight;
        if (random <= 0) {
          toolIcon = tool.icon;
          break;
        }
      }
      
      if (!toolIcon) {
        toolIcon = this.mechanicTools[0].icon;
      }
    }
    
    const padding = 50;
    const x = padding + Math.random() * (window.innerWidth - padding * 2);
    const y = padding + Math.random() * (window.innerHeight - padding * 2);
    
    const size = isSpecial ? 80 + Math.random() * 40 : 40 + Math.random() * 40;
    
    const color = isSpecial ? '#FFD700' : this.toolColors[Math.floor(Math.random() * this.toolColors.length)];
    
    const vx = (Math.random() - 0.5) * 3;
    const vy = (Math.random() - 0.5) * 3;
    
    const rotationSpeed = (Math.random() - 0.5) * 4;
    
    const animationType = Math.floor(Math.random() * 3) + 1;
    
    const toolElement = this.renderer.createElement('div');
    this.renderer.addClass(toolElement, 'tool-item');
    this.renderer.setStyle(toolElement, 'width', `${size}px`);
    this.renderer.setStyle(toolElement, 'height', `${size}px`);
    this.renderer.setStyle(toolElement, 'left', `${x}px`);
    this.renderer.setStyle(toolElement, 'top', `${y}px`);
    this.renderer.setStyle(toolElement, 'opacity', '0');
    
    const icon = this.renderer.createElement('i');
    this.renderer.addClass(icon, 'fas');
    this.renderer.addClass(icon, toolIcon);
    this.renderer.setStyle(icon, 'color', color);
    this.renderer.setStyle(icon, 'fontSize', `${size * 0.6}px`);
    
    if (isSpecial) {
      const glow = this.renderer.createElement('div');
      this.renderer.addClass(glow, 'tool-glow');
      this.renderer.setStyle(glow, 'background', `radial-gradient(circle, rgba(255,215,0,0.6) 0%, rgba(255,215,0,0) 70%)`);
      this.renderer.appendChild(toolElement, glow);
      
      this.renderer.setStyle(icon, 'transform', 'scale(1.2)');
    }
    
    switch (animationType) {
      case 1:
        this.renderer.setStyle(toolElement, 'animation', `float ${3 + Math.random() * 2}s infinite ease-in-out`);
        break;
      case 2:
        this.renderer.setStyle(icon, 'animation', `spin ${5 + Math.random() * 5}s infinite linear`);
        break;
      case 3:
        this.renderer.setStyle(toolElement, 'animation', `pulse ${2 + Math.random() * 2}s infinite ease-in-out`);
        break;
    }
    
    this.renderer.appendChild(toolElement, icon);
    this.renderer.appendChild(toolsContainer, toolElement);
    
    setTimeout(() => {
      this.renderer.setStyle(toolElement, 'opacity', '1');
      this.renderer.setStyle(toolElement, 'transition', 'opacity 0.3s ease-in');
    }, 10);
    
    this.toolItems.push({
      icon: toolIcon,
      x,
      y,
      size,
      color,
      vx,
      vy,
      rotation: Math.random() * 360,
      rotationSpeed,
      isSpecial,
      animationType,
      element: toolElement
    });
  }
  
  animateTools() {
    if (!this.easterEggActive) return;
    
    this.toolItems.forEach(tool => {
      tool.x += tool.vx;
      tool.y += tool.vy;
      tool.rotation += tool.rotationSpeed;
      
      if (tool.x <= 0 || tool.x >= window.innerWidth - tool.size) {
        tool.vx *= -1;
        tool.vx = tool.vx * (0.9 + Math.random() * 0.2);
      }
      if (tool.y <= 0 || tool.y >= window.innerHeight - tool.size) {
        tool.vy *= -1;
        tool.vy = tool.vy * (0.9 + Math.random() * 0.2);
      }
      
      if (tool.element) {
        this.renderer.setStyle(tool.element, 'left', `${tool.x}px`);
        this.renderer.setStyle(tool.element, 'top', `${tool.y}px`);
        
        if (tool.animationType !== 2) {
          this.renderer.setStyle(tool.element, 'transform', `rotate(${tool.rotation}deg)`);
        }
      }
    });
    
    this.animationId = requestAnimationFrame(() => this.animateTools());
  }

  navigateTo(route: string) {
    if (route) {
      let url: string;
      let queryParams: any = {};
      const baseUrl = this.routerLink_URL.startsWith('/') ? this.routerLink_URL : `/${this.routerLink_URL}`;

      switch (route) {
        case 'filtros':
          url = `${baseUrl}/filtros`;
          queryParams = { typeFilter: 'oscillogram' };
          break;
        case 'diagramas':
          url = `${baseUrl}/filtros`;
          queryParams = { typeFilter: 'diagram' };
          break;
        case 'falhas':
          url = `${baseUrl}/filtros`;
          queryParams = { typeFilter: 'failure' };
          break;
        case 'gerador':
          url = `${baseUrl}/filtros`;
          queryParams = { typeFilter: 'generator' };
          break;
        default:
          url = `${baseUrl}/${route}`;
          break;
      }
      this._router.navigate([url], { queryParams });
    }
  }

  detectar_mobile() {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.whatsApp = "https://api.whatsapp.com/send?phone=554499818097";
    }
    else {
      this.whatsApp = "https://web.whatsapp.com/send?phone=554499818097";
    }
  }
}

interface ToolItem {
  icon: string;
  x: number;
  y: number;
  size: number;
  color: string;
  vx: number;
  vy: number;
  rotation: number;
  rotationSpeed: number;
  isSpecial: boolean;
  animationType: number;
  element: HTMLElement | null;
}